export const Constants = {
    M365Portal: "M365Portal",
    allEnvs: ["development", "Prod", "AG08", "AG09", "PPE", "Bleu", "Delos"],
    prodAndAGOnlyEnvs: ["development", "Prod", "AG08", "AG09", "PPE"],
    ppeAndAGOnlyEnvs: ["development", "AG08", "AG09", "PPE"],
    prodOnlyEnvs: ["development", "Prod", "PPE"],
    prodAndSovereignEnvs: ["development", "Prod", "PPE", "Bleu", "Delos"],
    ppeOnlyEnvs: ["development", "PPE"],
    devOnlyEnvs: ["development"],
    ppeAndProdOnlyEnvs: ["Prod", "PPE"],
    sovereignOnlyEnvs: ["Bleu", "Delos"],
    sovereignBleuOnlyEnv: ["Bleu"],
    sovereignDelosOnlyEnv: ["Delos"],
    defaultWorkload: "Exchange",
    defaultTeamPublicId: "EXCHANGE\\OSP",
    defaultIcmService: "EXCHANGE"
};
